var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlusBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0013 6.83464H6.83464V11.0013C6.83464 11.4596 6.45964 11.8346 6.0013 11.8346C5.54297 11.8346 5.16797 11.4596 5.16797 11.0013V6.83464H1.0013C0.542969 6.83464 0.167969 6.45964 0.167969 6.0013C0.167969 5.54297 0.542969 5.16797 1.0013 5.16797H5.16797V1.0013C5.16797 0.542969 5.54297 0.167969 6.0013 0.167969C6.45964 0.167969 6.83464 0.542969 6.83464 1.0013V5.16797H11.0013C11.4596 5.16797 11.8346 5.54297 11.8346 6.0013C11.8346 6.45964 11.4596 6.83464 11.0013 6.83464Z",
    fill: "#077CA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusBlue);
export default __webpack_public_path__ + "static/media/icon_plus_blue.fc14205fbcba8792e972647c23feb056.svg";
export { ForwardRef as ReactComponent };